import React from "react";

interface SkeltonProps {
  type?: "circle" | "text";
  width?: string;
  height?: string;
  animation?: string;
  istextRounded?: string;
}

const Skelton: React.FC<SkeltonProps> = ({
  type = "text",
  width = "w-full",
  height = "h-2.5",
  animation = "animate-pulse",
  istextRounded = "rounded-lg",
}) => {
  const isType = type;

  return (
    <div role="status" className={`space-y-2.5 ${animation} max-w-lg`}>
      <div className="flex items-center w-full">
        {/* Conditionally render circle or text skeletons based on the type prop */}
        {isType === "circle" ? (
          <div
            className={`rounded-full bg-slate-200 dark:bg-gray-700" ${width} ${height}`}
          />
        ) : (
          <>
            <div
              className={`bg-slate-200  dark:bg-gray-700 ${istextRounded} ${width} ${height}`}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(Skelton);
